export default __webpack_public_path__ + "static/media/email.a1ee0d05.svg";